import { createApi } from '@reduxjs/toolkit/query/react';
import { appPortalBaseQuery } from '@/features/baseQuery.ts';
import { withScopeQuery } from '@/features/analytics/analytics-scope.ts';
import type { AnalyticsScope } from '@/features/analytics/analytics-scope.def.ts';
import type { BackendNavBreakdownReportDto } from '@/features/reports/reports.def.ts';

export const reportsApi = createApi({
  reducerPath: 'reportsApi',
  baseQuery: appPortalBaseQuery(),
  tagTypes: ['NavBreakdownReport'],
  endpoints: (builder) => ({
    getNavBreakdownReport: builder.query<BackendNavBreakdownReportDto, AnalyticsScope | void>({
      query: (scope) => ({
        url: withScopeQuery('/reports/nav-breakdown', scope),
        method: 'GET',
      }),
      providesTags: ['NavBreakdownReport'],
    }),
  }),
});

export const { useGetNavBreakdownReportQuery } = reportsApi;
